<template>
    <div>
        <el-dialog :title="title" :visible.sync="visible" width="600px" :close-on-click-modal="false">
            <Language :add="add" v-model="form.lang" @change="handleLangChange" style="margin-top: -20px"></Language>
            <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="form.sort" placeholder="请输入排序"></el-input>
                </el-form-item>
                <el-form-item label="系列" prop="type">
                    <el-select disabled v-model="form.type" placeholder="请选择系列" style="width: 100%">
                        <el-option label="连接器" value="1"></el-option>
                        <el-option label="工具" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="parent_cuuid" label="上级分类" prop="parent_cuuid">
                    <CategorySelector disabled parent v-model="form.parent_cuuid" style="width: 100%"></CategorySelector>
                </el-form-item>
                <el-form-item label="分类名称" prop="name">
                    <el-input v-model="form.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item label="分类图标" prop="icon">
                    <Uploader size="small" v-model="form.icon"></Uploader>
                </el-form-item>
                <el-form-item label="关联标签" prop="label">
                    <LabelSelector multiple v-model="form.label" style="width: 100%"></LabelSelector>
                </el-form-item>
                <el-form-item label="是否显示" prop="status">
                    <el-switch v-model="form.status"></el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="visible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirm">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/product/category";
import Uploader from "@/components/Uploader";
import LabelSelector from "@/components/LabelSelector";
import Language from "@/components/Language";
import CategorySelector from "@/components/CategorySelector";
import { getUuid } from "@/jslibs/utils";
export default {
    components: { Uploader, LabelSelector, Language, CategorySelector },
    data() {
        return {
            title: "新增分类",
            visible: false,
            form: {
                sort: "",
                type: "",
                name: "",
                icon: "",
                label: [],
                status: true,
            },
            rules: {
                sort: [{ required: true, message: "请输入排序" }],
                type: [{ required: true, message: "请选择系列" }],
                name: [{ required: true, message: "请输入分类名称" }],
                icon: [{ required: true, message: "请选择分类图标" }],
            },
            parent: true,
            type: "",
            parent_cuuid: "",
            cuuid: "",
            uuid: "",
            add: true,
        };
    },
    methods: {
        open({ parent, type, parent_cuuid, cuuid, uuid }) {
            this.visible = true;
            this.parent = parent;
            this.type = type;
            this.parent_cuuid = parent_cuuid;
            this.cuuid = cuuid;
            this.uuid = uuid;
            if (uuid) {
                this.add = false;
                this.title = "编辑分类";
                this.getDetail("zh");
            } else {
                this.add = true;
                this.form = {};
                this.title = "新增分类";
                this.form.cuuid = getUuid();
                this.cuuid = this.form.cuuid;
                this.form.lang = "zh";
                this.form.type = type;
                if (!parent) {
                    this.form.parent_cuuid = parent_cuuid;
                }
                this.$nextTick(() => {
                    this.$refs.form.clearValidate();
                });
            }
        },
        handleLangChange(lang) {
            this.getDetail(lang);
        },
        getDetail(lang) {
            detail({ cuuid: this.cuuid, lang }).then(({ code, result, error }) => {
                if (code == 200) {
                    this.form = result
                        ? { ...result, status: result.status == 1, label: result.label.map((x) => x.uuid), parent_cuuid: this.parent_cuuid }
                        : { cuuid: this.cuuid, lang, type: this.type, parent_cuuid: this.parent_cuuid };
                    if (this.form.fid != "0") {
                        this.parent_cuuid = result ? this.form.parent.cuuid : this.parent_cuuid;
                        this.form.parent_cuuid = this.parent_cuuid;
                    }
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    ...this.form,
                    status: this.form.status ? "1" : "2",
                };
                if (!this.form.uuid) {
                    add(params).then(({ code, error }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
							this.visible = false;
                            this.$emit("update");
                        } else {
                            this.$message.error(error.message);
                        }
                    });
                } else {
                    if (this.cuuid) {
                        params.uuid = this.form.uuid;
                        edit(params).then(({ code, error }) => {
                            if (code == 200) {
                                this.$message.success("编辑成功");
								this.visible = false;
                                this.$emit("update");
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    } else {
                        add(params).then(({ code, error }) => {
                            if (code == 200) {
                                this.$message.success("添加成功");
								this.visible = false;
                                this.$emit("update");
                            } else {
                                this.$message.error(error.message);
                            }
                        });
                    }
                }
            });
        },
    },
};
</script>

<style></style>
